/**
 * 自定义进制数相关工具
 */

/**
 * 十进制数转换为自定义进制数
 * @param scaleList 自定义进制数集合
 * @param decimalNum 十进制数
 */
 function decimal2Scale(scaleList, decimalNum) {
  if (!decimalNum && decimalNum !== 0) {
    return scaleList;
  }
  //整数部分
  let integerPart;
  //小数部分
  let decimalPart;
  //上一位数
  let before;
  if (decimalNum != 0 && Number(decimalNum) == 0) {
    return;
  }
  if (scaleList.length == 1) {
    //只有一个数 不做处理
    scaleList[0].value = decimalNum;
    return;
  }
  scaleList.forEach((item, index) => {
    //多位进制数处理
    let val;
    if (index == 0) {
      //第一位数直接取传入值作为实际数值
      val = decimalNum;
    } else {
      //不是第一位数 前置位余下的小数部分乘以进位 为该位的实际数值
      val = decimalPart * item.digit;
    }
    if ((index + 1) != scaleList.length) {
      //中间位
      //整数部分
      integerPart = Math.floor(val);
      //计算小数部分用于后置位取值
      decimalPart = val - integerPart;
    } else {
      //最后一位 直接四舍五入取值
      integerPart = Math.round(val);
    }
    if (index != 0 && integerPart == item.digit) {
      //不是第一位 并且达到进位标准
      before.value++;
      integerPart = 0;
    }
    //赋值
    item.value = integerPart;
    //记录上一位
    before = item
  })
}

/**
 * 自定义进制数转换为十进制数
 * @param scaleList 自定义进制数集合
 * @returns {string}
 */
function scale2Decimal(scaleList) {
  //检查是否有值
  let isNull = true
  scaleList.forEach(item => {
    //有一个字段有值 则不是null
    if (item.value) {
      isNull = false
    }
  })
  if (isNull) return null
  //记录十进制值
  let decimalNum = 0
  //进位倍率
  let scale = 1
  scaleList.forEach((item, index) => {
    let value = item.value || 0
    if (index == 0) {
      //第一位直接加
      decimalNum += Number(value)
      return
    }
    //后置位要计算出全部的进位倍率
    scale = (scale * item.digit)
    //位置除以前置位的进位倍率得出实际数值
    decimalNum += Number(value / scale)
  })
  return decimalNum.toFixed(5)
}

export default {
  decimal2Scale,
  scale2Decimal
}